
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.091-.45-.254-.611zm-1.755.69h-6.325V2.979l6.325 6.323zM6.009 31.27V2.73h13.649v7.438c0 .478.387.865.865.865h7.468V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm4.548 5.441h-1.049l-1.621 2.592-1.631-2.592H8.952l2.141 3.354-2.192 3.409h1.054l1.673-2.639 1.663 2.639h1.058l-2.187-3.409m4.12-3.355h-.897v6.764h4.102v-.73h-3.205m7.788-2.552c-.317-.189-.757-.364-1.319-.522-.562-.158-.96-.333-1.194-.524-.234-.19-.351-.424-.351-.7 0-.345.123-.613.369-.808.246-.194.589-.291 1.029-.291.473 0 .841.117 1.1.352.26.234.391.557.391.968h.896c0-.375-.099-.72-.299-1.037a2.05 2.05 0 00-.845-.743 2.766 2.766 0 00-1.243-.269c-.682 0-1.235.174-1.661.522-.426.348-.639.789-.639 1.322 0 .47.175.866.522 1.187.349.321.906.591 1.67.81.611.177 1.031.355 1.264.537.232.181.349.438.349.769s-.125.592-.376.785c-.251.192-.611.287-1.083.287-.504 0-.908-.119-1.21-.355-.302-.238-.453-.56-.453-.969h-.896c0 .394.109.745.328 1.054.218.31.528.554.931.732.403.178.836.267 1.301.267.715 0 1.287-.165 1.714-.496.427-.329.641-.768.641-1.316 0-.343-.076-.643-.229-.896-.154-.253-.39-.475-.707-.666z"}})])])
          )
        }
      }
    